<template>
    <cic-popup
        :title="item.profileId ? 'Edit Dial Times Profile' : 'New Dial Times Profile'"
        :editable="item.profileId > 0 && $store.hasRight('DIAL_RIGHTS_EDIT_REDDIAL_DIALTIMES_PROFILES')"
        :exportable="item.profileId > 0"
        :saveable="item.profileId <= 0 || $store.hasRight('DIAL_RIGHTS_EDIT_REDDIAL_DIALTIMES_PROFILES')"
        @blur="$emit('blur')"
        @edit="toggleEdit"
        @export="$store.exportFile({ link: 'dialtimesprofile/export', params: { profileId: item.profileId } })"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul>
                <li class="form-label-first">
                    {{ $t('Name') }}
                </li>
                <li>
                    <cic-textbox
                        id="profile_name"
                        :value="item.name"
                        :enabled="editing"
                        :maxlength="256"
                        @input="(val) => $emit('updateFieldValue', 'name', val)"
                    />
                </li>
                <template v-if="editing">
                    <li class="form-label">
                        {{ $t('Dial Times Import') }}
                    </li>
                    <li>
                        <input id="fImport" type="file" @change="readFile" />
                    </li>
                </template>
                <li class="form-label">
                    {{ $t('Dial Times') }}
                </li>
                <li>
                    <table id="times_table" class="cic-table">
                        <thead>
                            <tr>
                                <th>{{ $t('Value') }}</th>
                                <th style="width: 120px">
                                    {{ $t('Start Time') }}
                                </th>
                                <th style="width: 120px">
                                    {{ $t('End Time') }}
                                </th>
                                <template v-if="editing">
                                    <th>&nbsp;</th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(time, timeIndex) in item.members">
                                <td>
                                    <cic-textbox
                                        :value="time.column"
                                        :enabled="editing"
                                        :maxlength="256"
                                        @input="(val) => updateMember(timeIndex, 'column', val)"
                                    />
                                </td>
                                <td>
                                    <cic-time-picker
                                        :value="time.start"
                                        :clearable="false"
                                        :enabled="editing"
                                        format="HH:mm"
                                        @input="(val) => updateMember(timeIndex, 'start', val)"
                                    />
                                </td>
                                <td>
                                    <cic-time-picker
                                        :value="time.end"
                                        :clearable="false"
                                        :enabled="editing"
                                        format="HH:mm"
                                        @input="(val) => updateMember(timeIndex, 'end', val)"
                                    />
                                </td>
                                <template v-if="editing">
                                    <td style="padding: 0">
                                        <icon-button
                                            v-if="item.members.length > 1"
                                            icon="remove-icon"
                                            @click="removeTime(timeIndex)"
                                        />
                                    </td>
                                </template>
                            </tr>
                            <tr v-if="editing && item.members.length < limit">
                                <td colspan="3"></td>
                                <td style="padding: 0">
                                    <icon-button icon="add-icon" @click="addTime" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </li>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import IconButton from '@/components/controls/IconButton';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import CicTimePicker from '@/components/inputs/CicTimePicker';
    import File from '@/mixins/File';
    import { showErrorMessage } from '@/utils/Notification';

    export default {
        name: 'EditDialTimesProfile',
        components: {
            CicPopup,
            CicTextbox,
            CicTimePicker,
            IconButton,
        },
        mixins: [File],
        props: {
            item: {
                type: Object,
                required: true,
            },
            limit: {
                type: Number,
                default: 10,
            },
        },
        emits: ['blur', 'input', 'updateFieldValue'],
        data() {
            return {
                editing: false,
            };
        },
        created() {
            this.editing = this.item.profileId <= 0;
        },
        methods: {
            addTime() {
                let members = JSON.parse(JSON.stringify(this.item.members));
                members.push({
                    start: '00:00',
                    end: '00:00',
                    column: null,
                });
                this.$emit('updateFieldValue', 'members', members);
            },

            fileOnLoad(content) {
                try {
                    let lines = this.parseCsv(content);
                    this.$emit(
                        'updateFieldValue',
                        'members',
                        lines
                            .filter((x) => x[0].trim() !== this.$t('Value'))
                            .map((x) => {
                                return { column: x[0].trim(), start: x[1].trim(), end: x[2].trim() };
                            }),
                    );
                } catch (err) {
                    showErrorMessage(this.$t('CSV_PARSE_FAILED'));
                }
            },

            removeTime(index) {
                let members = JSON.parse(JSON.stringify(this.item.members));
                members.splice(index, 1);
                this.$emit('updateFieldValue', 'members', members);
            },

            toggleEdit() {
                this.editing = !this.editing;
            },

            updateMember(index, field, value) {
                let members = JSON.parse(JSON.stringify(this.item.members));
                members[index][field] = value;
                this.$emit('updateFieldValue', 'members', members);
            },
        },
    };
</script>
